<template>
  <div class="dialog-ai-cvs-wrapper">

    <!-- Container -->
    <div class="dialog-ai-cvs-container" @click="showPositionSelect = false">

      <!-- Header -->
      <div class="dialog-ai-cvs-container-header">

        <!-- tab -->
        <div class="dialog-ai-cvs-container-header-tab">
          <span :class="{'active': tabIndex === 0}" @click="tabIndex = 0">自动写</span>
          <span :class="{'active': tabIndex === 1}" @click="tabIndex = 1">简历润色</span>
          <i :class="['dialog-ai-cvs-container-header-tab-sign', `position-${tabIndex}`]"></i>
        </div>

        <!-- close -->
        <div class="dialog-ai-cvs-container-header-close" @click="$emit('close')">
          <i class="iconfont iconx"></i>
        </div>

      </div>

      <!-- Content -->
      <div class="dialog-ai-cvs-container-content">

        <!-- Tab Index 0 -->
        <template v-if="tabIndex === 0">

          <div class="dialog-ai-cvs-container-content-input-box">
            <input v-model="inputValue" type="text">
            <button class="dialog-ai-cvs-button fill" @click="go()">GO</button>
          </div>

          <div class="dialog-ai-cvs-container-content-tag-box">
            <label>经验年限</label>
            <span :class="{'active': (indexExp === expIndex) && !isCustomInput}" v-for="(itemExp, indexExp) in expArr" :key="indexExp" @click="toggleExpTag(indexExp)">{{ itemExp }}</span>
          </div>

          <div class="dialog-ai-cvs-container-content-tag-box">

            <label>职位类型</label>
            <span :class="{'active': (indexPst === pstIndex) && !isCustomInput}" v-for="(itemPst, indexPst) in pstArr" :key="indexPst" @click="togglePstTag(indexPst)">{{ itemPst }}</span>

            <span :class="{'active': ((positionSelectIndex === pstIndex) && !isCustomInput) || showPositionSelect}" @click.stop="togglePositionSelect()"><i class="iconfont iconsearch"></i>{{ positionSelectValue || '搜索职位' }}</span>
            <div class="dialog-ai-cvs-container-content-position-select" v-show="showPositionSelect" @click.stop>

              <div class="dialog-ai-cvs-container-content-position-select-menu">
                <!-- Menu（一级） -->
                <label :class="{'active': indexFirst === positionMenuIndex}" v-for="(itemFirst, indexFirst) in positionArr" :key="itemFirst.profession_id" @click="positionMenuIndex = indexFirst">{{ itemFirst.title }}</label>
              </div>

              <div class="dialog-ai-cvs-container-content-position-select-content">
                <!-- Content 二级 -->
                <div class="dialog-ai-cvs-container-content-position-select-content-block" v-for="itemSecond in positionArr[positionMenuIndex].list" :key="itemSecond.profession_id" v-show="!itemSecond.label.includes('其他')">
                  <h6>{{ itemSecond.label }}</h6>
                  <!-- Content 三级 -->
                  <ul>
                    <li v-show="!itemThird.label.includes('其他')"
                        v-for="itemThird in itemSecond.list"
                        :key="itemThird.profession_id"
                        :class="{'active': positionSelectValue === itemThird.label}"
                        @click="selectThirdPosition(itemThird.label)">
                      {{ itemThird.label }}
                    </li>
                  </ul>
                </div>
              </div>

            </div>

          </div>

        </template>
        <!-- Tab Index 1 -->
        <template v-else-if="tabIndex === 1">

          <div class="dialog-ai-cvs-container-content-text-area">
            <h6>原文<span @click="copyCvsText()">使用简历内容</span></h6>
            <div>

            <Editor
                class="dialog-ai-textarea"
                v-model="textareaValue"
                :defaultConfig="editorOption2"
                mode="default"
                @onCreated="onCreated2"
                @onFocus="textareaFocus"
                @onBlur="textareaBlur"
            />

              <!-- <editor class="dialog-ai-textarea" v-model="textareaValue" :init="editorOption"></editor> -->
              <!-- <textarea v-model="textareaValue" @focus="isFucosTextarea = true" @blur="textareaBlur" :placeholder="placeholderText"></textarea> -->
            </div>
            <ol class="dialog-ai-cvs-container-content-text-area-tips" v-show="showTips">
              <button class="dialog-ai-cvs-container-content-text-area-tips-btn" @click="copyCvsText()">使用简历内容</button>
              <i class="iconfont iconcha"></i>
            </ol>
          </div>

          <div class="dialog-ai-cvs-container-content-button-handle">
            <span></span>
            <div>
              <button class="dialog-ai-cvs-button fill" @click="go()">GO</button>
            </div>
          </div>

        </template>

        <!-- Result Preview -->
        <div class="dialog-ai-cvs-container-content-text-area">
          <h6>生成结果</h6>
          <div v-if="isLoading" class="dialog-ai-cvs-container-content-text-area-loading">
             <i class="dialog-ai-cvs-container-content-text-area-loading-icon"></i>
          </div>
          <template v-else>
            <!-- <div v-if="tabIndex === 1 && !resultValue">
              <textarea :placeholder="placeholderText"></textarea>
            </div> -->

            <!-- <div v-else v-html="resultValue" class="result-preview"></div> -->

            <Editor
                class="dialog-ai-textarea"
                v-model="resultValue"
                :defaultConfig="{...editorOption, placeholder: (tabIndex === 1) ? placeholder1 : ''}"
                mode="default"
                @onCreated="onCreated"
            />
            <!-- <editor class="dialog-ai-textarea" v-model="resultValue" :init="editorOption"></editor> -->

          </template>
        </div>

        <!-- Result Handle -->
        <div class="dialog-ai-cvs-container-content-button-handle">
          <span>Powered By ChatGPT</span>
          <div>
            <button class="dialog-ai-cvs-button transparent" @click="go()"><i class="iconfont iconhuanyihuan1"></i>重试</button>
            <button class="dialog-ai-cvs-button fill" :class="{'disabled': !resultValue}" :disabled="!resultValue" @click="editCvs()">用于简历</button>
          </div>
        </div>

        <!-- Loading Mask -->
        <div v-if="isLoading" class="dialog-ai-cvs-loading-mask"></div>

      </div>

      <div v-show="tabIndex === 0" style="height:97px;background:transparent;"></div>

    </div>

  </div>
</template>

<script>
import api from '@/api'
import { mapState } from 'vuex'
import tinymce from 'tinymce/tinymce'
// import Editor from "@tinymce/tinymce-vue"
import { Editor } from '@wangeditor/editor-for-vue'

export default {
  components: { Editor },
  data () {
    return {
      tabIndex: 0, // 0自动写 1简历润色
      expIndex: 1, // 经验年限 索引 可能的值 1. null（自定义输入） 2. number
      pstIndex: 1, // 职位类型 索引 可能的值 1. null（自定义输入） 2. number 3. 999（职位弹窗）
      backupExpIndex: 1,
      backupPstIndex: 1,

      inputValue: '请帮我写一段1～3年经验产品经理岗位的经历描述', // 自动写 值
      textareaValue: '', // 简历润色 值

      positionSelectIndex: 999, // 职位搜索弹窗的 指定索引
      positionSelectValue: '', // 职位搜索弹窗 选择的 职位类型
      showPositionSelect: false, // 控制 职位搜索弹窗的显示与隐藏
      positionMenuIndex: 0, // 控制 职位搜索弹窗的内容展示
      positionArr: [{list: []}], // 位搜索弹窗里的数据

      resultValue: '', // 最总结果

      tinymceEditorText: '',
      isFucosTextarea: false,

      isLoading: false,

      editor: null,
      editor2: null,

      editorOption: {
        readOnly: true
      },
      placeholder1: `优化后：<br/>
              1.配合项目洽谈和需求跟进，成功完成XX个项目并达到XX的商业目标。<br/>
              2.通过外包产品设计和自研项目管理，管理XX个产品并实现了XX的收入增长。<br/>
              3.丰富的供应商采购谈判和产品对接经验，在XX期间，成功将XX种产品引入公司并提高了XX%的毛利润。`,
      editorOption2: {
        placeholder: `优化前：<br/>
                      1.配合项目洽谈和需求跟进。<br/>
                      2.外包产品设计、自研项目管理。<br/>
                      3.供应商采购谈判和产品对接`
      },
      expArr: [
        '1年以内',
        '1-3年',
        '3-5年',
        '5年以上'
      ],
      pstArr: [
        '运营',
        '产品经理',
        '前端开发',
        '数据分析',
        '设计师'
      ]
    }
  },
  created () {
    this.getProfessionsTree()
    this.getTinymceEditorContent()
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  computed: {
    ...mapState('me', [ 'isMembership' ]),

    // check 自动写 input 是否为自定义输入
    isCustomInput () {
      const reg = /^请帮我写一段(\S*)经验(\S*)岗位的经历描述$/
      return !reg.test(this.inputValue)
    },
    // 经验年限的文本
    expText () {
      return this.expArr[this.expIndex]
    },
    // 职位类型的文本
    pstText () {
      // 选择的 搜索职位 tag 并且 选择了职位
      if (this.pstIndex === 999 && this.positionSelectValue) {
        return this.positionSelectValue
      } else {
        return this.pstArr[this.pstIndex]
      }
    },
    // 固定的 input value
    defaultInputValue () {
      // check index 没有值
      if (!this.expText || !this.pstText) return ''
      // check pstIndex 是否
      return `请帮我写一段${this.expText}经验${this.pstText}岗位的经历描述`
    },
    // 显示 tips
    showTips () {
      return (this.isFucosTextarea && (this.textareaValue === '<p><br></p>') && this.tinymceEditorText)
    }
  },
  // 处理 副作用
  watch: {
    tabIndex (newValue, oldValue) {
      if (newValue === oldValue) return
    },
    expIndex (newValue, oldValue) {
      if (newValue === oldValue) return
    },
    pstIndex (newValue, oldValue) {
      if (newValue === oldValue) return
    },
    positionMenuIndex (newValue, oldValue) {
      if (newValue === oldValue) return
    },
    // exp pst index 变化时，赋值到 input
    defaultInputValue (newValue, oldValue) {
      if (!newValue) return
      this.inputValue = newValue
    },
    // 值变化为 自定义时 存储当前 expIndex pstIndex
    isCustomInput (newValue) {
      if (newValue) {
        this.backupExpIndex = this.expIndex
        this.backupPstIndex = this.pstIndex
        this.expIndex = null
        this.pstIndex = null
      }
    }
  },
  methods: {
    onCreated (editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onCreated2 (editor) {
      this.editor2 = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    getTinymceEditorContent () {
      const text = tinymce.activeEditor.getContent()
      this.tinymceEditorText = text
    },
    // 简历内容复制到
    copyCvsText () {
      // const text = tinymce.activeEditor.getContent()
      this.textareaValue = this.tinymceEditorText
    },
    // 结果复制给简历
    editCvs () {
      tinymce.activeEditor.setContent(this.tinymceEditorText + '<br/>' +  this.resultValue)
      tinymce.activeEditor.execCommand('mceInsertContent',false, '')
      this.$emit('close')
    },
    //
    go () {
      let params = null
      let callback = null
      let positionFlag = (this.pstIndex === 999 && this.positionSelectValue)
      if (this.tabIndex === 0) {

        // 校验
        if (!this.inputValue) {
          this.$message.error('请先输入需要自动写的内容')
          return
        }

        // 会员阻断（自定义输入 或者 选择了职位弹窗里的职位）
        if (!this.isMembership) {
          if (positionFlag || this.isCustomInput) {
            this.$store.dispatch('app/setAlertData', {
              show: true,
              type: 'upVip',
              origin: 'ai-cvs',
              browseType: 'aiCvs'
            })
            return
          }
        }

        callback = (result) => {
          this.resultValue = result
        }

        // 选择的固定职位
        if (positionFlag || this.isCustomInput) {
          params = {
            text: this.inputValue,
            text_type: 2
          }
          this.getAIResult(params, callback)
        } else {
          params = {
            experience: this.expText,
            job_type: this.pstText
          }
          this.getResult(params, callback)
        }

      } else if (this.tabIndex === 1) {

        // 校验
        if (!this.textareaValue) {
          this.$message.error('请先输入需要润色的内容')
          return
        }

        // 会员阻断（自定义输入 或者 选择了职位弹窗里的职位）
        if (!this.isMembership) {
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'upVip',
            origin: 'ai-cvs',
            browseType: 'aiCvs'
          })
          return
        }

        params = {
          text: this.textareaValue,
          text_type: 1
        }
        callback = (result) => {
          this.resultValue = result
        }
        this.getAIResult(params, callback)
      }
    },
    // 切换 职位弹窗显示和隐藏
    togglePositionSelect () {
      // this.pstIndex = this.positionSelectIndex
      this.showPositionSelect = !this.showPositionSelect
    },
    //
    selectThirdPosition (val) {
      this.pstIndex = this.positionSelectIndex
      this.positionSelectValue = val
    },
    textareaFocus (e, o) {
      console.log(e, o)
      this.isFucosTextarea = true
    },
    //
    textareaBlur (e, o) {
      console.log(e, o)
      this.isFucosTextarea = false
      return
      if (e.relatedTarget && e.relatedTarget.className === 'dialog-ai-cvs-container-content-text-area-tips-btn') return
    },
    //
    toggleExpTag (i) {
      if (this.pstIndex === null) {
        this.pstIndex = this.backupPstIndex
      }
      this.expIndex = i
    },
    //
    togglePstTag (i) {
      if (this.expIndex === null) {
        this.expIndex = this.backupExpIndex
      }
      this.pstIndex = i
    },
    // 获取 AI 结果
    async getAIResult (params, callback) {
      try {
        this.isLoading = true
        let res = await api.AI.getAIWriteResult(params)
        if (res.code === 1000) {
          let data = res.data.result
          if (!data) {
            this.$message.error('AI 开小差了~')
          }
          callback && callback(data)
        } else if (res.code === 20216) {
          this.$message.error('我只是个AI，不懂你在说什么~')
        } else if (res.code === 20263) {
          this.$message.error('AI 出了点状况，请稍后再试')
        } else {
          this.$message.error(res.message)
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log(error)
      }
    },
    // 获取 固定 结果
    async getResult (params, callback) {
      try {
        this.isLoading = true
        let res = await api.AI.getWriteResult(params)
        if (res.code === 1000) {
          if (!res.data.result || !res.data.result.length) {
            this.$message.error('AI 开小差了~')
          }
          let data = res.data.result[0].result
          callback && callback(data)
        } else if (res.code === 20216) {
          this.$message.error('我只是个AI，不懂你在说什么~')
        } else if (res.code === 20263) {
          this.$message.error('AI 出了点状况，请稍后再试')
        } else {
          this.$message.error(res.message)
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log(error)
      }
    },
    //获取树形结构的职位类型
    async getProfessionsTree(){
      try {
        let res = await api.staticApi.getProfessionsTree()
        if (res.code === 1000) {
          this.positionArr = res.data
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}


</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
  .dialog-ai-cvs-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .dialog-ai-cvs-container {
      position: relative;
      width: 800px;
      border-radius: 8px;
      font-family: PingFangSC-Regular, PingFang SC;

      &-header {
        height: 68px;
        padding: 0 32px;
        background: #F8FAFF;
        border-radius: 8px 8px 0 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &-tab {
          position: relative;
          display: flex;
          gap: 30px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 1;

          >span {
            display: inline-block;
            padding: 10px 0;
            cursor: pointer;
            &.active {
              color: #404040;
              font-weight: bold;
            }
          }

          &-sign {
            position: absolute;
            bottom: 0;
            width: 16px;
            height: 2px;
            background: #FF6644;
            border-radius: 1px;
            transition: left 0.4s ease;

            &.position-0 {
              left: 18px;
            }

            &.position-1 {
              left: 112px;
            }

          }

        }

        &-close {
          cursor: pointer;
          padding: 6px;
          margin-right: -6px;
          .iconx {
            font-size: 24px;
            font-weight: bold;
          }
        }

      }

      &-content {
        padding: 24px 32px 32px;
        border-radius: 0 0 8px 8px;
         background: #FFF;

        &-input-box {
          display: flex;
          gap: 24px;
          align-items: center;
          height: 44px;
          border-radius: 4px;
          border: 1px solid #ECECEC;
          padding: 0 6px 0 12px;
          margin-bottom: 24px;

          >input {
            height: 100%;
            flex: 1;
            border: none;
            background: transparent;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #404040;
            line-height: 1;
          }
        }

        &-tag-box {
          position: relative;
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          >label {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #606060;
            line-height: 1;
            margin-right: 16px;
          }

          >span {
            display: flex;
            align-items: center;
            gap: 2px;
            height: 36px;
            box-sizing: border-box;
            position: relative;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #404040;
            line-height: 1;
            padding: 0 22px;
            border-radius: 4px;
            border: 1px solid #ECECEC;
            margin-left: 12px;
            cursor: pointer;
            overflow: hidden;

            >.iconfont {
              font-size: 16px;
              margin-right: 2px;
            }

            &::after {
              display: none;
              content: "✓";
              position: absolute;
              right: 0;
              bottom: 0;
              width: 0;
              height: 0;
              color: #FFF;
              font-size: 12px;
              border: 9px solid #FF6644;
              border-top-color: transparent;
              border-left-color: transparent;
            }

            &:first-of-type {
              margin-left: 0;
            }

            &:last-of-type {
              padding-top: 8px;
              padding-bottom: 8px;
              line-height: 16px;
              display: inline-block;
              justify-content: center;
              max-width: 120px;
              box-sizing: border-box;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            &:hover,
            &.active {
              color: #FF6644;
              border-color: #FF6644;
              &::after {
                display: block;
              }
            }
          }

        }

        &-position-select {
          display: flex;
          position: absolute;
          left: 0;
          top: 46px;
          width: 100%;
          height: 270px;
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid #ECECEC;
          background: #FFF;
          z-index: 1;

          &-menu {
            width: 123px;
            height: 100%;
            overflow-y: auto;
            background: #F9F9F9;

            >label {
              text-align: center;
              display: inline-block;
              padding: 11px 10px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #606060;
              line-height: 1;
              width: 100%;
              box-sizing: border-box;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;

              &:hover,
              &.active {
                color: #404040;
                font-weight: 500;
                background: #FFF;
              }

            }
          }

          &-content {
            flex: 1;
            height: 100%;
            overflow-y: auto;
            padding: 0 12px 16px;
            box-sizing: border-box;

            &-block {
              margin-top: 16px;

              >h6 {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: #606060;
                line-height: 1;
                margin-bottom: 12px;
              }

              >ul {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;

                >li {
                  list-style: none;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #9C9C9C;
                  line-height: 1;
                  padding: 8px 16px;
                  border-radius: 15px;
                  border: 1px solid #ECECEC;
                  cursor: pointer;

                  &:hover,
                  &.active {
                    color: #FF6644;
                    border-color: #FF6644;
                  }
                }
              }
            }
          }

        }

        &-text-area {
          position: relative;
          border-radius: 4px;
          border: 1px solid #DEDFE1;
          margin-top: 24px;
          height: 203px;
          box-sizing: border-box;

          &:nth-of-type(1) {
            margin-top: 0;
          }

          &-tips {
            position: absolute;
            top: 78px;
            left: 0;
            padding: 14px 16px;
            box-shadow: 0px 0px 10px 0px rgba(6,4,67,0.1);
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #404040;
            line-height: 1;
            border-radius: 4px;
            background: #FFF;

            &-btn {
              background: transparent;
              border: none;
            }

            &::before {
              content: "";
              position: absolute;
              top: -20px;
              left: -4px;
              width: 40px;
              height: 40px;
              background: #FFF;
              box-shadow: -5px -5px 10px -4px rgba(6,4,67,0.1);
              transform: scale(0.3) rotate(45deg);
            }

            >span {
              cursor: pointer;
            }

            .iconfont {
              color: #9c9c9c;
              font-size: 14px;
              cursor: pointer;
            }

          }

          &-loading {
            display: flex;
            align-items: center;
            justify-content: center;

            &-icon{
              width: 20px;
              height: 20px;
              border: 2px solid #DEDFE1;
              border-top-color: transparent;
              border-radius: 100%;
              animation: circlePay infinite 0.75s linear;
              margin-left: 5px;
              margin-right: 4px;
            }
            @keyframes circlePay {
              0% {
                transform: rotate(0);
              }
              100% {
                transform: rotate(360deg);
              }
            }

          }

          >h6 {
            padding: 12px 16px;
            background: #F9F9F9;
            border-radius: 4px 4px 0px 0px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #404040;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;

            >span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #4183FF;
              line-height: 14px;
              cursor: pointer;
            }
          }

          >div {
            // padding: 8px 0 8px 16px;
            // padding-left: 16px;
            // height: 163px;
            // box-sizing: border-box;
            // overflow: auto;

            // >textarea {
            //   width: 100%;
            //   margin: 0px;
            //   padding: 0px;
            //   box-sizing: border-box;
            //   border: none;
            //   height: 15px;
            //   outline: none;
            //   resize: none;
            //   height: 129px;
            //   font-family: PingFangSC-Regular, PingFang SC;
            // }

          }

        }

        &-button-handle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 16px;

          >span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #B8B8B8;
            line-height: 14px;
          }

          >div {
            display: flex;
            gap: 16px;
          }
        }

      }

      .dialog-ai-cvs-loading-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
      }

    }

    .dialog-ai-cvs-button {
      padding: 8px 16px;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 1;
      border-width: 1px;
      border-style: solid;
      display: flex;
      align-items: center;
      gap: 2px;
      background: transparent;

      &:hover {
        opacity: 0.8;
      }

      &.transparent {
        border-color: #FF6644;
        color: #FF6644;
      }

      &.fill {
        border-color: #FF6644;
        background: #FF6644;
        color: #FFF;
      }

      &.disabled {
        // cursor: not-allowed;
        opacity: 0.8;
      }

      i {
        font-size: 14px;
      }

    }

    .dialog-ai-textarea {
      width: 100%;
      height: 163px;
      margin: 0px;
      padding: 0px;
      padding-left: 16px;
      box-sizing: border-box;
      border: none;
      outline: none;
      resize: none;
      box-sizing: border-box;
      font-style: none;
      font-family: PingFangSC-Regular, PingFang SC;
      // overflow-y: auto;
    }

    .result-preview {
      line-height: 1.5;
    }

    .dialog-ai-cvs-container-content-text-area-loading {
      margin-top: 60px;
    }

    ::v-deep .w-e-text-container [data-slate-editor] {
      padding: 0;
    }
    ::v-deep .w-e-text-placeholder {
      width: 100%;
    }

  }
</style>
